// extracted by mini-css-extract-plugin
module.exports = {"map":"Map_map__3W29M","icon":"Map_icon__2mtjS","tiles":"Map_tiles__1gedI"};